export const SET_PARTNER = "SET_PARTNER";

export const setPartner = (partner) => {
  return {
    type: SET_PARTNER,
    payload: partner,
  };
};
